//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateRegistroEgresos } from "@/typings/store/plugins/easyFirestore/registrosEgresos";

const getters: GetterTree<StateRegistroEgresos, State> = {
  get(state) {
    return state.all;
  },
  getArray(state) {
    return Object.values(state.all);
  },
};

const registrosEgresos = {
  firestorePath: "dev/v1/registrosEgresos",
  firestoreRefType: "collection",
  moduleName: "registrosEgresos",
  statePropName: "all",
  namespaced: true,
  serverChange: {
    convertTimestamps: {
      created_at: "%convertTimestamp%", // default
      updated_at: "%convertTimestamp%", // default
    },
  },
  state: {},
  getters,
  mutations: {},
  actions: {},
};

export default registrosEgresos;
